export default "__VITE_ASSET__20bbc1cf__"